import {
  exactWindow,
  projectIdsParam,
} from '@/components/analytics/objections/objections-search';
import { MISSED_CALLS_MAX_WINDOW_DAYS } from '@aica/api-types/schemas';

/**
 * Параметры адреса экранов «Статистика звонков» и «Пропущенные» — точное окно,
 * проекты, канал и правило демо, с которыми их открывает ссылка «Отчёт →»
 * карточки единого дашборда. Период экраны держат в состоянии, а не в адресе:
 * ссылка сообщает только то, что посчитала карточка, а первый же шаг по периоду
 * возвращает экран к обычным периодам (проекты и канал остаются — это фильтры).
 */
export interface FlowReportSearch {
  /** ISO instants, both or neither. */
  from?: string;
  to?: string;
  projectIds?: string[];
  /**
   * Which records «Статистика звонков» counts: `call` (the page's own default),
   * `chat`, or `all` — both, as the dashboard's channel filter when it is off.
   * «Пропущенные» are calls whatever this says.
   */
  channel?: FlowReportChannel;
  demo?: 'yes' | 'no';
}

export const FLOW_REPORT_CHANNELS = ['call', 'chat', 'all'] as const;
export type FlowReportChannel = (typeof FLOW_REPORT_CHANNELS)[number];

/**
 * The widest window either screen counts — what `/missed-calls` takes (a year
 * with a leap day). `/call-stats` takes any window; one limit keeps the two
 * screens' links alike.
 */
export const FLOW_REPORT_MAX_WINDOW_DAYS = MISSED_CALLS_MAX_WINDOW_DAYS;

export function parseFlowReportSearch(search: Record<string, unknown>): FlowReportSearch {
  const exact = exactWindow(search.from, search.to, FLOW_REPORT_MAX_WINDOW_DAYS);
  const demo = search.demo === 'yes' || search.demo === 'no' ? search.demo : undefined;
  const channel = FLOW_REPORT_CHANNELS.find((c) => c === search.channel);
  const projectIds = projectIdsParam(search.projectIds);
  return {
    ...(exact ?? {}),
    ...(projectIds.length > 0 ? { projectIds } : {}),
    ...(channel ? { channel } : {}),
    ...(demo ? { demo } : {}),
  };
}
